import { render, staticRenderFns } from "./AppLabel.vue?vue&type=template&id=4e92f670&"
import script from "./AppLabel.vue?vue&type=script&lang=js&"
export * from "./AppLabel.vue?vue&type=script&lang=js&"
import style0 from "./AppLabel.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports